import { serviceUrl } from '../../AppConfig';

let url = serviceUrl + 'API/ExternalSizing/GetSSETUrl';
let deleteUrl = serviceUrl + 'API/ExternalSizing/DeleteGuidance';
let successString = 'SUCCESS';
let tokenId = '__antiForgeryToken';


const getHeaders = () => {
  let antiForgeryTokenField = document.getElementById(tokenId);
  //Creating headers only once
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Cache", "no-cache");
  myHeaders.append("CSRFToken", antiForgeryTokenField.value);
  return myHeaders
}


export const redirectToSSET = (id,isReviewed) => {

  let attribute = '?&reviewed=';
  let isTrue='true';
  let isFalse='false';

  if (isReviewed) {
    url += attribute+isTrue;
  } else {
    url += attribute+isFalse;
  }
  let verb = 'GET';
  fetch(url, {
    method: verb,
    headers: getHeaders(),
    credentials: 'same-origin'
  })
    .then((response) => response.json())
    .then(function (data) {
      window.location.replace(data + id.trim())
    });
}

export const clearSSETDataAndRedirect = (userId, id,isReviewed) => {
  let payload = [{
    "guidanceId": id,
    "userEmail": userId
  }]

  let raw = JSON.stringify(payload);
  let verb = 'POST';
  let requestOptions = {
    method: verb,
    headers: getHeaders(),
    body: raw,
    credentials: 'same-origin'
  };

  fetch(deleteUrl, requestOptions)
    .then(response => response.json())
    .then(result => {      
      if (result.status.toUpperCase() === successString) {
        redirectToSSET(id,isReviewed);
      }
    })
    .catch(error => console.log(error));
}


// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/Utils.js